import { Locale } from 'modules/i18n';

export const addToWalletMenuItemTranslation = {
  [Locale.en]: {
    addToWallet: 'Add to wallet',
  },
};
